import { render, staticRenderFns } from "./CopyGroupDrawer.vue?vue&type=template&id=51bcb7e2&scoped=true"
import script from "./CopyGroupDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyGroupDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyGroupDrawer.vue?vue&type=style&index=0&id=51bcb7e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bcb7e2",
  null
  
)

export default component.exports